// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Verdana, Arial, Helvetica, sans-serif;
}

input[type="file"] {
  background: #efefef;
}

li {
 padding: 5px;
}

#output {
  margin-top: 10px;
}

#output p {
  margin-top: 10px;
  margin-bottom: 0;
  background: #efefef;
  text-align: right;
  font-size: small;
}

#output textarea {
  width: 99%;
}

.error {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./dev/style.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;CACC,YAAY;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ","sourcesContent":["body {\n  font-family: Verdana, Arial, Helvetica, sans-serif;\n}\n\ninput[type=\"file\"] {\n  background: #efefef;\n}\n\nli {\n padding: 5px;\n}\n\n#output {\n  margin-top: 10px;\n}\n\n#output p {\n  margin-top: 10px;\n  margin-bottom: 0;\n  background: #efefef;\n  text-align: right;\n  font-size: small;\n}\n\n#output textarea {\n  width: 99%;\n}\n\n.error {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
